import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import Metrics from '@spotahome/soyuz-tracking';

import Feature from '../Feature';
import InstantBookingLabelCircledIcon from '../../icons/InstantBookingLabelCircledIcon';
import { INSTANT_BOOKING_FEATURE } from '../featureList';
import openInstantBookingModal from '../../InstantBookingModal';

import styles from '../ValuePropositionFeatures.module.scss';

const InstantBookingFeature = ({ onCollapsedChange, collapsed, rules = [] }) => {
  const handleIBModalOpen = e => {
    e.preventDefault();
    Metrics.hotjar.triggerEvent('listing-IB-modal-click');
    openInstantBookingModal({ rules });
  };

  const renderBody = () => (
    <div
      role="button"
      tabIndex={-1}
      className={`${styles['instant-booking__body']} ga-instant-booking-ru-conditions`}
      onClick={handleIBModalOpen}
      dangerouslySetInnerHTML={{
        __html: trans('property_show.book_now_card.instant_booking.body')
      }}
    />
  );

  return (
    <Feature
      collapsed={collapsed}
      onCollapsedChange={onCollapsedChange}
      featureName={INSTANT_BOOKING_FEATURE}
      renderBody={renderBody}
      renderIcon={() => <InstantBookingLabelCircledIcon />}
      headerKey="property_show.book_now_card.instant_booking"
    />
  );
};

InstantBookingFeature.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onCollapsedChange: PropTypes.func.isRequired,
  rules: PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string, params: PropTypes.shape({}) }))
};

export default InstantBookingFeature;
